const helpContent = `
<div style="margin: 20px 0;">
  <h3>Available Commands:</h3>
  <p style="margin: 10px 0;">
    <span class="command-link" data-command="who" style="color: #5abb9a;">[who] or [w]</span><br>
    <span class="command-link" data-command="skills" style="color: #5abb9a;">[skills] or [s]</span><br>
    <span class="command-link" data-command="projects" style="color: #5abb9a;">[projects] or [pj]</span><br>
    <span class="command-link" data-command="misc" style="color: #5abb9a;">[miscellaneous] or [misc]</span><br>
    <span class="command-link" data-command="games" style="color: #5abb9a;">[games] or [g]</span><br>
    <span class="command-link" data-command="blog" style="color: #5abb9a;">[blog] or [b]</span><br>
    <span class="command-link" data-command="resume" style="color: #5abb9a;">[resume] or [cv]</span><br>
    <span class="command-link" data-command="clear" style="color: #5abb9a;">[clear]</span>
  </p>
  
  <h3>Contact Me:</h3>
  <p style="margin: 10px 0;">
    <span class="command-link" data-command="email" style="color: #5abb9a;">[email]</span><br>
    <span class="command-link" data-command="linkedin" style="color: #5abb9a;">[linkedin]</span><br>
    <span class="command-link" data-command="twitter" style="color: #5abb9a;">[twitter]</span><br>
    <span class="command-link" data-command="github" style="color: #5abb9a;">[github]</span><br>
  </p>
</div>`;

export default helpContent;